import { colors } from '@aloft/toolkit-sui';
import { View } from '@react-pdf/renderer';

import { tableStyles } from '../Table/tableStyles.js';
import { sharedStyles } from '../sharedStyles.js';
import { TdProps } from './types.js';

export function Td({
  isFirstColumn = false,
  isFirstRow = false,
  children,
  width,
  height,
  minHeight,
  border,
  justifyContent,
  gap,
  style,
  backgroundColor,
  textAlign,
}: TdProps) {
  return (
    <View
      style={[
        tableStyles.cell,
        sharedStyles.fullWidth,
        sharedStyles.verticalCenter,
        {
          borderWidth: border ? undefined : 1,
          borderStyle: border ? undefined : 'solid',
          borderColor: border ? undefined : colors.strokeDefault,
          borderLeftWidth: isFirstColumn ? 1 : 0,
          borderTopWidth: isFirstRow ? 1 : 0,
          width,
          height,
          minHeight,
          paddingVertical: height ? 0 : tableStyles.cell.paddingVertical,
          border,
          justifyContent,
          gap,
          backgroundColor: backgroundColor ? colors[backgroundColor] : undefined,
          textAlign,
        },
        style ? style : {},
      ]}
    >
      {children}
    </View>
  );
}
